module.exports = __webpack_public_path__ + "static/media/riskStep3.a47a2b94.svg";